import { render, staticRenderFns } from "./BlogHead.vue?vue&type=template&id=0260b720&"
import script from "./BlogHead.vue?vue&type=script&lang=js&"
export * from "./BlogHead.vue?vue&type=script&lang=js&"
import style0 from "./BlogHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports